export default {
    '2b-diagram5': {
        'diagram-task': 'Identify the question that the main point raises, and the grouped ideas answer.',
        'checkboxes': {
            'title': 'Question:',
            'checkbox-1': 'How?',
            'checkbox-2': 'Why?',
            'checkbox-3': 'How know?'
        },
        'elements': {
            'one': 'Creating narratives is a powerful way to pass on information',
            'two': 'Listing facts imposes a heavy burden on memory',
            'three': 'Relating them as a plot turns them into a single piece of information',
            'four': 'A plot can be easily communicated to others',
        }
    }
}



// WEBPACK FOOTER //
// ./client/app/components/diagrams/2/2b/diagram5/i18n/en.js